<template>
  <div>
    <b-link
      @click="openModal()"
      v-if="canDecreaseProjectBudget && isTotalObligatedDataLoaded"
      class='add-link text-right'>
      Decrease Project Budget
    </b-link>
    <b-modal
      id="projectDecreaseModal"
      @hidden="cancelDecrease"
      title="Decrease Project Budget"
      size="xl">
      <LoadingSpinner v-if='fundingSourcesLoading'
        message ='Loading Funding Source' size = '1x'>
      </LoadingSpinner>
      <template v-else>
        <p>Indicate the funding source and amount of decrease to the overall Project Budget.
          IMPORTANT: you cannot undo this operation.</p>
        <b-alert
          :show="decreaseValidationMessage !== ''"
          dismissible
          variant="danger"
        >
          {{ decreaseValidationMessage }}
        </b-alert>
        <VueFormGenerator
          :schema="getProjectDecreaseSchema()"
          :model="currentProjectDecrease"
          :options="{
          validateAfterLoad: false,
          validateAfterChanged: true,
          validateAsync: true
          }"
          @validated="onDecreaseValidation"
        />
      </template>
      <template v-slot:modal-footer>
        <b-button
          size="sm"
          variant="danger"
          @click="$bvModal.hide('projectDecreaseModal')"
          class='management-plan-dialog-no'>
          Cancel
        </b-button>
        <b-button
          :disabled="!validDecrease"
          size="sm"
          variant="success"
          @click="addProjectDecrease"
          class='management-plan-dialog-yes'>
          Add Item
        </b-button>
      </template>
    </b-modal>
    <b-alert
      :show="decreaseErrorMessage !== ''"
      dismissible
      variant="danger"
    >
      {{ decreaseErrorMessage }}
    </b-alert>
    <b-alert
      :show="successDismissCountDown"
      dismissible
      variant="success"
      @dismissed="successDismissCountDown=0"
      @dismiss-count-down="successCountDownChanged"
    >
      {{ successMessage }}
    </b-alert>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AlertManager from '@/mixins/AlertManager';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';
import ProjectBudgetHelper from '@/mixins/projectBudgetHelper';
import ProjectBudgetHelperExpenditureSummary from '@/mixins/projectBudgetHelperExpenditureSummary';
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';

export default {
  name: 'ProjectBudgetHistory',
  mixins: [
    AlertManager,
    ProjectApprovalMembershipManager,
    ProjectBudgetHelper,
    ProjectBudgetHelperExpenditureSummary,
    ProjectTotalsCalculator,
  ],
  computed: {
    ...mapState(['config']),
    ...mapState('Project', {
      successMessage: (state) => state.decreaseSuccessMessage,
      decreaseErrorMessage: (state) => state.decreaseErrorMessage,
      fundingSources: (state) => state.fundingSources,
      fundingSourcesLoading: (state) => state.fundingSourcesLoading,
      projectBudget: (state) => state.projectBudget,
      projectSnapshot: (state) => state.projectSnapshot,
      projectWorkorders: (state) => state.projectWorkorders,
      projectWorkorderBills: (state) => state.projectWorkorderBills,
      projectWorkorderLineItemFundingSources: (state) => state.projectWorkorderLineItemFundingSources,
      incentiveTypes: (state) => state.incentiveTypes,
    }),
    isTotalObligatedDataLoaded() {
      let totalObligatedDataLoaded = false;
      if (this.projectWorkorders && this.projectWorkorders != null && this.projectWorkorderBills && this.projectWorkorderBills != null) {
        totalObligatedDataLoaded = true;
      }
      return totalObligatedDataLoaded;
    },
  },
  data() {
    return {
      currentProjectDecrease: {},
      validDecrease: false,
      projectBudgetValidationResults: [],
      decreaseValidationMessage: '',
      visible: false,
    };
  },
  mounted() {
    this.currentProjectDecrease = this.initProjectDecrease();
  },
  methods: {
    initProjectDecrease() {
      this.$store.dispatch('Project/setDecreaseErrorMessage', '');
      this.decreaseValidationMessage = '';
      return {
        decreaseAmount: null,
        fundingSourceId: null,
        projectBudgetId: this.projectBudget.id,
      };
    },
    openModal() {
      if (this.projectExpenditureTotalProjectCost <= this.projectExpenditureTotalObligated) {
        this.$bvModal.msgBoxOk('All project funds have been obligated. You cannot decrease the project budget.');
      } else {
        this.currentProjectDecrease = this.initProjectDecrease();
        this.$bvModal.show('projectDecreaseModal');
      }
    },
    addProjectDecrease() {
      if (this.currentProjectDecrease.decreaseAmount > this.projectExpenditureTotalProjectCost - this.projectExpenditureTotalObligated) {
        this.decreaseValidationMessage = 'The funding source selected does not have sufficient remaining unobligated funds to use for the indicated budget decrease amount. Please ensure that proceeding with this operation is tracked appropriately outside Acorn.';
      } else {
        this.$bvModal.hide('projectDecreaseModal');
        this.$store.dispatch('Project/addProjectDecrease', this.currentProjectDecrease).then(() => {
          if (this.successMessage) {
            this.showSuccessAlert();
            // this.loadHistoryItems();
            this.$store.dispatch('Project/forceFetchProjectBudget', this.projectBudget.projectId);
            this.$store.dispatch('Project/getProjectSnapshot', this.projectBudget.projectId);
            this.$store.dispatch('Project/getProjectBudgetYearSnapshots', this.projectBudget.projectId);
            this.visible = true;
          } else {
            this.visible = true;
          }
        });
        this.currentProjectDecrease = this.initProjectDecrease();
      }
    },
    cancelDecrease() {
      this.currentProjectDecrease = this.initProjectDecrease();
    },
    onDecreaseValidation(isValid) {
      this.validDecrease = isValid
        && this.currentProjectDecrease.fundingSourceId
        && this.currentProjectDecrease.decreaseAmount
        && this.currentProjectDecrease.decreaseAmount > 0;
    },
  },
};
</script>
